import React, { useState } from 'react';
import { Button } from './ui/button';
import { Mail, CheckCircle, Loader2 } from 'lucide-react';
import axios from 'axios';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');
  const [sectionRef, sectionVisible] = useScrollAnimation({ threshold: 0.2 });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setStatus('loading');
    try {
      const response = await axios.post(`${API}/newsletter`, { email });
      setStatus('success');
      setMessage(response.data.status === 'existing' 
        ? 'You\'re already subscribed!' 
        : 'Successfully subscribed!');
      setEmail('');
    } catch (error) {
      setStatus('error');
      setMessage('Failed to subscribe. Please try again.');
    }
  };

  return (
    <section className="newsletter-section" data-testid="newsletter-section">
      <div className="container">
        <div 
          ref={sectionRef}
          className={`newsletter-wrapper animate-scale ${sectionVisible ? 'is-visible' : ''}`}
        >
          <div className={`newsletter-content animate-slide-up ${sectionVisible ? 'is-visible' : ''}`}>
            <Mail className="newsletter-icon" />
            <h3 className="newsletter-title">Stay Updated</h3>
            <p className="newsletter-subtitle">
              Get the latest AI news, course updates, and exclusive offers
            </p>
          </div>

          <form className={`newsletter-form animate-slide-up ${sectionVisible ? 'is-visible' : ''} stagger-2`} onSubmit={handleSubmit}>
            {status === 'success' ? (
              <div className="success-message">
                <CheckCircle className="success-icon" />
                <span>{message}</span>
              </div>
            ) : (
              <>
                <div className="input-wrapper">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    className="newsletter-input"
                    required
                    data-testid="newsletter-email-input"
                  />
                </div>
                <Button 
                  type="submit" 
                  className="btn-primary newsletter-btn hover-glow"
                  disabled={status === 'loading'}
                  data-testid="newsletter-submit-btn"
                >
                  {status === 'loading' ? (
                    <><Loader2 className="spinner" /> Subscribing...</>
                  ) : (
                    'Subscribe'
                  )}
                </Button>
              </>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
